export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  borderRight: '1px solid',
  borderColor: 'divider',
  minWidth: 240,
};

export const emptyStyles = {
  padding: 2,
  color: 'text.secondary',
};

export const loadingStyles = {
  display: 'flex',
  justifyContent: 'center',
  padding: 2,
};
